import { render, staticRenderFns } from "./LogoFooter.vue?vue&type=template&id=8f5e568a&lang=html&"
import script from "./LogoFooter.vue?vue&type=script&lang=ts&"
export * from "./LogoFooter.vue?vue&type=script&lang=ts&"
import style0 from "./LogoFooter.vue?vue&type=style&index=0&id=8f5e568a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports